import {Component} from "../../../../../sedestral/framework/interface/component/Component";
import * as s from "./progressbar-semi.scss";
import ProgressBar from 'progressbar.js';
import {IProgressBarSemi} from "./types/IProgressBarSemi";
import {randomUUID} from "../../../../../sedestral/framework/utilities/RandomUUID";

export class ProgressBarSemiComponent extends Component {

    public id: string;
    public settings: IProgressBarSemi;
    public progressBar: ProgressBar.SemiCircle;

    public valueContainer: Component;
    public titleContainer: Component;

    constructor(settings: IProgressBarSemi) {
        super();
        this.id = randomUUID();
        this.settings = settings;

        //language=HTML
        this.template = `
            <div class="${s.componentProgressBarSemi} ${settings.arc ? s.arc : ``}">
                <div class="${s.texts}">
                    <div class="${s.value}"></div>
                    <div class="${s.title}"></div>
                </div>
                <svg id="svg${this.id}"
                     width="120" height="120" viewBox="0 0 120 120" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    ${settings.arc ? `
                    <path id="background${this.id}" stroke="#ECECEC" stroke-width="5" stroke-linecap="round"
                          fill="none" d="M20,60 A40,40 0 0,1 100,60"/>
                    <path id="progressBar${this.id}" stroke="#3ECE80" stroke-width="5" stroke-linecap="round"
                          fill="none" d="M20,60 A40,40 0 0,1 100,60"/>
                    ` : `
                    <path id="background${this.id}" stroke="#ECECEC" stroke-width="5" stroke-linecap="round"
                          d="M31.7678 88.2322C26.184 82.6484 22.3813 75.5342 20.8408 67.7893C19.3002 60.0443 20.0909 52.0164 23.1128 44.7208C26.1347 37.4252 31.2522 31.1896 37.8181 26.8024C44.3839 22.4152 52.1033 20.0736 60 20.0736C67.8967 20.0736 75.6161 22.4152 82.1819 26.8024C88.7478 31.1896 93.8653 37.4252 96.8872 44.7208C99.9091 52.0164 100.7 60.0443 99.1592 67.7893C97.6187 75.5342 93.816 82.6484 88.2322 88.2322"/>
                    <path id="progressBar${this.id}" stroke="#3ECE80" stroke-width="5" stroke-linecap="round"
                          d="M33.6098 89.9612C27.5247 84.6014 23.2159 77.5158 21.2566 69.647C19.2973 61.7782 19.7804 53.4994 22.6417 45.9119C25.503 38.3245 30.6067 31.7881 37.274 27.1725C43.9412 22.5568 51.8559 20.0807 59.9649 20.0736C68.0739 20.0665 75.9929 22.5287 82.6683 27.1326C89.3436 31.7365 94.4589 38.2639 97.3335 45.8463C100.208 53.4287 100.706 61.7067 98.7603 69.5789C96.8149 77.4511 92.5185 84.5443 86.4428 89.9148"/>
                    `}
                </svg>
            </div>
        `;
    }

    commit() {
        this.valueContainer = this.el(s.value);
        this.titleContainer = this.el(s.title);

        this.progressBar = new ProgressBar.Path(`#progressBar${this.id}`, {
            easing: 'easeInOut',
            duration: 1400,
            step: (state, bar) => {
                this.valueContainer.setHtml(`<div style="font-size: ${this.settings.valueFontSize}px;color:black;">${this.settings.value}<span style="font-size: ${this.settings.valueFontSize * 0.66} px;">${this.settings.hideValue ? `` : `/${this.settings.maxValue}`}</span></div>`);
                if (this.settings.title)
                    this.titleContainer.setHtml(`<div style="font-size: ${this.settings.titleFontSize}px;color:${this.color()};">${this.title()}</div>`);

                this.onUpdate();
            },
        });
        this.progressBar.set(0);
        this.progressBar.animate(0.9);

        this.getElementProgressBar().setAttribute("stroke-width", "" + this.settings.strokeWidth);
        this.getElementBackground().setAttribute("stroke-width", "" + this.settings.strokeWidth);
        this.getElementSvg().setAttribute("width", "" + this.settings.size);
        this.getElementSvg().setAttribute("height", "" + this.settings.size);

        this.updateValue(this.settings.value);

        super.commit();
    }

    color(): string {
        let v = this.settings.value;
        if (v < this.settings.midValue) {
            return this.settings.badColor;
        } else if (v >= this.settings.midValue && v < this.settings.goodValue) {
            return this.settings.midColor;
        } else if (v >= this.settings.goodValue && v < this.settings.midEndValue) {
            return this.settings.goodColor;
        } else if (v > this.settings.maxValue && v <= this.settings.midEndValue) {
            return this.settings.midColor;
        } else {
            return this.settings.badColor;
        }
    }

    description(): string {
        let v = this.settings.value;
        if (v < this.settings.midValue) {
            return this.settings.badDescription;
        } else if (v >= this.settings.midValue && v < this.settings.goodValue) {
            return this.settings.midDescription;
        } else if (v >= this.settings.goodValue && v <= this.settings.maxValue) {
            return this.settings.goodDescription;
        } else if (v > this.settings.maxValue && v <= this.settings.midEndValue) {
            return this.settings.midEndDescription;
        } else {
            return this.settings.badEndDescription;
        }
    }

    title(): string {
        let v = this.settings.value;
        if (v < this.settings.midValue) {
            return this.settings.badTitle;
        } else if (v >= this.settings.midValue && v < this.settings.goodValue) {
            return this.settings.midTitle;
        } else if (v >= this.settings.goodValue && v <= this.settings.maxValue) {
            return this.settings.goodTitle;
        } else if (v > this.settings.maxValue && v <= this.settings.midEndValue) {
            return this.settings.midTitle;
        } else {
            return this.settings.badTitle;
        }
    }

    updateValue(value: number) {
        this.settings.value = value;
        let animateValue = value > this.settings.maxValue ? this.settings.maxValue : value;
        this.progressBar.animate((animateValue * 100 / this.settings.maxValue) / 100);

        this.updateColor();
    }

    updateColor() {
        this.getElementProgressBar().setAttribute('stroke', this.color());
    }

    getElementSvg() {
        return document.getElementById(`svg${this.id}`);
    }

    getElementBackground() {
        return document.getElementById(`background${this.id}`);
    }

    getElementProgressBar() {
        return document.getElementById(`progressBar${this.id}`);
    }

    onUpdate() {

    }

}